import {
    setSliceTabIndex,
    setSliceLanguageList,
    setSliceVoiceInfo,
    setSliceStyleInfo,
    setSliceFavoriteList,
    setSliceCurrentVoiceFromType,
    setSliceCurrentAvatarUrl,
    setSliceCurrentVoiceUrl,
    setSliceCurrentName,
    setSliceCurrentStyle,
    setSliceCurrentSpeed,
    setSliceCurrentPitch,
    setSliceCurrentSpeechList,
    setSliceRecentUseVoiceList,
    setSliceCurrentCountryInfo,
    setSliceCurrentStyleList,
    setSliceIsShowLibraryModal,
    setSliceSpeechSelectId,
    setSliceSpeechLanguageValue,
    setSliceFreeNumCreationTextToSpeech,
    setSliceFreeNumCreationOfVoiceClone,
    setSliceLoadingFavoriteIdList,
    setSliceCurrentBottomCurrentTime,
    setSliceCurrentBottomTotalTime,
    setSliceIsPlayingInBottom,
    setSliceCurrentBottomSpeechId,
    setSliceLoadingFavoriteListStatus,
    setSliceDownloadStatus,
} from '../slices/FJSliceTextToSpeech.js';
import FJNetworkStore from '../../store/FJNetworkStore.js';
import FJConfig from '../../config/FJConfig.js';
import FJMessageStore from '../../store/FJMessageStore.js';
import FJLocalStore from '../../store/FJLocalStore.js';
import FJTextToSpeechData from '../../config/dataConfig/FJTextToSpeechData.js';
import FJStringUtil from '../../util/FJStringUtil.js';
import FJConstant from '../../constants/FJConstant.js';
import FJTextToSpeechStore from '../../store/FJTextToSpeechStore.js';
import { MAX_POLLING_ERROR_TIME, TASK_POLLING_INTERVAL } from '../../config/dataConfig/FJGenerateData';
import FJUtil from '../../util/FJUtil.js';
import FJActionTextToSpeechProject from './FJActionTextToSpeechProject.js';
import FJTextToSpeechConfig from '../../config/appConfig/FJTextToSpeechConfig.js';
import FJS3Config from '../../config/FJS3Config.js';
import FJFileHandleUtil from '../../util/FJFileHandleUtil.js';
import FJTTSPlayStore from '../../store/FJTTSPlayStore.js';
import FJTextToSpeechUtil from '../../util/FJTextToSpeechUtil.js';
import FJActionCommon from './FJActionCommon.js';
import FJActionModal from './FJActionModal.js';
import FJAudioPlayManager from '../../store/FJAudioPlayManager.js';
import { setSliceUpgradeTipsModalData } from '../slices/FJSliceModals.js';
import FJImageStore from '../../store/FJImageStore.js';

let f_recordNeedDownloadIdList = [];
const MAX_LIMIT = 60;

// TODO 这个得改
let f_currentVoiceInfo = null;
const FJActionTextToSpeech = {
    updateUseFreeLimitAction: function (info) {
        return dispatch => {
            dispatch(setSliceFreeNumCreationTextToSpeech(info['text-to-audio']));
            dispatch(setSliceFreeNumCreationOfVoiceClone(info['fish-speech']));
        };
    },
    setSliceLoadingFavoriteListStatusAction: function (status) {
        return dispatch => {
            dispatch(setSliceLoadingFavoriteListStatus(status));
        };
    },

    setSliceDownloadStatusAction: function (status) {
        return dispatch => {
            dispatch(setSliceDownloadStatus(status));
        };
    },

    setSliceCurrentBottomSpeechIdAction: function (id) {
        return dispatch => {
            dispatch(setSliceCurrentBottomSpeechId(id));
        };
    },

    setSliceIsPlayingInBottomAction: function (isPlaying) {
        return dispatch => {
            dispatch(setSliceIsPlayingInBottom(isPlaying));
        };
    },

    setSliceCurrentBottomCurrentTimeAction: function (currentTime) {
        return dispatch => {
            dispatch(setSliceCurrentBottomCurrentTime(currentTime));
        };
    },

    setSliceCurrentBottomTotalTimeAction: function (totalTime) {
        return dispatch => {
            dispatch(setSliceCurrentBottomTotalTime(totalTime));
        };
    },

    setSliceSpeechLanguageValueAction: function (value) {
        return dispatch => {
            dispatch(setSliceSpeechLanguageValue(value));
        };
    },
    setSliceCurrentVoiceFromTypeAction: function (type) {
        return dispatch => {
            dispatch(setSliceCurrentVoiceFromType(type));
        };
    },

    setSliceCurrentAvatarUrlAction: function (url) {
        return dispatch => {
            dispatch(setSliceCurrentAvatarUrl(url));
        };
    },

    setSliceCurrentVoiceUrlAction: function (url) {
        return dispatch => {
            dispatch(setSliceCurrentVoiceUrl(url));
        };
    },

    setSliceCurrentNameAction: function (name) {
        return dispatch => {
            dispatch(setSliceCurrentName(name));
        };
    },

    setSliceCurrentStyleAction: function (style) {
        return dispatch => {
            dispatch(setSliceCurrentStyle(style));
        };
    },

    setSliceCurrentSpeedAction: function (speed) {
        return dispatch => {
            dispatch(setSliceCurrentSpeed(speed));
        };
    },

    setSliceCurrentPitchAction: function (pitch) {
        return dispatch => {
            dispatch(setSliceCurrentPitch(pitch));
        };
    },

    setSliceCurrentSpeechListAction: function (list) {
        return dispatch => {
            dispatch(setSliceCurrentSpeechList(list));
        };
    },

    setSliceSpeechSelectIdAction: function (id) {
        return dispatch => {
            dispatch(setSliceSpeechSelectId(id));
        };
    },

    setSliceRecentUseVoiceListAction: function (list) {
        return dispatch => {
            dispatch(setSliceRecentUseVoiceList(list));
        };
    },

    setSliceCurrentCountryInfoAction: function (country) {
        return dispatch => {
            dispatch(setSliceCurrentCountryInfo(country));
        };
    },

    setSliceCurrentStyleListAction: function (list) {
        return dispatch => {
            dispatch(setSliceCurrentStyleList(list));
        };
    },

    setIsShowLibraryModalAction: function (isShow) {
        return dispatch => {
            dispatch(setSliceIsShowLibraryModal(isShow));
        };
    },

    changeTabIndexAction: function (index) {
        return dispatch => {
            dispatch(setSliceTabIndex(index));
        };
    },

    setLibraryDataAction: function (languageList, voiceInfo, styleInfo) {
        return dispatch => {
            dispatch(setSliceLanguageList(languageList));
            dispatch(setSliceVoiceInfo(voiceInfo));
            dispatch(setSliceStyleInfo(styleInfo));
        };
    },

    setFavoriteListAction: function (list) {
        return dispatch => {
            dispatch(setSliceFavoriteList(list));
        };
    },

    setLoadingFavoriteIdListAction: function (list) {
        return dispatch => {
            dispatch(setSliceLoadingFavoriteIdList(list));
        };
    },

    initAction: function () {
        return async dispatch => {
            const { languageList, voiceObj, styleObj } = await FJTextToSpeechUtil.getVoiceStyleList();
            dispatch(this.setSliceRecentUseVoiceListAction(FJTextToSpeechUtil.getRecentUseVoiceList()));
            dispatch(this.setLibraryDataAction(languageList, voiceObj, styleObj));
            dispatch(this.initDefaultVoiceAction());
            // dispatch(this.getFavoriteAction());
            // dispatch(FJActionTextToSpeechProject.getProjectList());

            const voiceId = FJUtil.getQueryString('voice_id');
            if (voiceId) {
                let voiceList = [];
                for (const key in voiceObj) {
                    const innerItem = voiceObj[key];
                    voiceList = [...voiceList, ...innerItem];
                }
                const info = voiceList.find(item => item.value === voiceId);
                if (info) {
                    dispatch(this.useVoiceItemAction(info, { fromType: info.type || FJConstant.MICROSOFT }));
                }
            }
        };
    },

    initDefaultVoiceAction: function () {
        return dispatch => {
            const currentTag = FJLocalStore.currentTag();
            const defaultVoice = FJTextToSpeechData.DEFAULT_VOICE[currentTag];
            dispatch(this.updateTextToSpeechVoiceInfoAction(defaultVoice));
            // TODO 根据预设调整
            // dispatch(this.setSliceCurrentVoiceFromTypeAction(FJConstant.MICROSOFT));
            dispatch(this.addSpeechParagraphAction());
        };
    },

    /**
     * @description
     * @param defaultVoice
     * @param options
     * @returns {(function(*, *): void)|*}
     */
    updateTextToSpeechVoiceInfoAction: function (defaultVoice, options = {}) {
        return (dispatch, getState) => {
            const { fromType = FJConstant.MICROSOFT } = options;

            switch (fromType) {
                case FJConstant.MICROSOFT: {
                    const { voiceInfo, styleInfo } = getState().textToSpeech;
                    if (defaultVoice) {
                        let voiceList = [];
                        for (const key in voiceInfo) {
                            const innerItem = voiceInfo[key];
                            voiceList = [...voiceList, ...innerItem];
                        }
                        const defaultVoiceItem = voiceList.find(item => item.value === defaultVoice.value);
                        if (defaultVoiceItem) {
                            const { value, text, url, languageInfo } = defaultVoiceItem;
                            f_currentVoiceInfo = defaultVoiceItem;
                            dispatch(this.setSliceCurrentAvatarUrlAction(FJStringUtil.getTextToSpeechImgUrl(value)));
                            dispatch(this.setSliceCurrentVoiceUrlAction(url));
                            dispatch(this.setSliceCurrentNameAction(text));
                            dispatch(this.setSliceCurrentCountryInfoAction({ ...languageInfo }));

                            const styleList = styleInfo[value];
                            const tempStyleList = styleList.map(item => ({
                                ...item,
                                value: item.id,
                                label: item.text,
                            }));
                            dispatch(this.setSliceCurrentStyleListAction(tempStyleList));
                            dispatch(this.setSliceCurrentStyleAction(tempStyleList[0].value));
                        }
                    }
                    break;
                }
                case FJConstant.CLONE_BY_SELF: {
                    f_currentVoiceInfo = defaultVoice;
                    const { audioUrl, avatar, name, lang, text, id } = defaultVoice;
                    const showLang =
                        FJTextToSpeechData.LANGUAGE_LIST.find(item => item.value === lang)?.label || 'English';
                    dispatch(this.setSliceCurrentAvatarUrlAction(FJConfig.profilePath + avatar + '.png'));
                    dispatch(this.setSliceCurrentVoiceUrlAction(audioUrl));
                    dispatch(this.setSliceCurrentNameAction(name));
                    dispatch(this.setSliceCurrentCountryInfoAction({ showLang: showLang, readText: text, id: id }));
                    break;
                }
                case FJConstant.CLONE_BY_FLEX_CLIP: {
                    f_currentVoiceInfo = defaultVoice;
                    const { value, label, languageInfo, readText } = defaultVoice;
                    dispatch(this.setSliceCurrentAvatarUrlAction(FJConfig.voiceCloneAvatarPath + value + '.png'));
                    dispatch(this.setSliceCurrentVoiceUrlAction(FJConfig.voiceCloneAudioPath + value + '.mp3'));
                    dispatch(this.setSliceCurrentNameAction(label));
                    dispatch(
                        this.setSliceCurrentCountryInfoAction({
                            ...languageInfo,
                            readText: readText,
                            value: value,
                        }),
                    );
                    break;
                }
                default:
            }
        };
    },

    getFavoriteAction: function () {
        return async dispatch => {
            if (FJUtil.isLogin()) {
                dispatch(this.setSliceLoadingFavoriteListStatusAction(FJConstant.LOADING));
                try {
                    const result = await FJNetworkStore.getFavoriteVoiceList();
                    dispatch(this.setFavoriteListAction(result.list.map(item => item.sound_id)));
                    dispatch(this.setSliceLoadingFavoriteListStatusAction(FJConstant.SUCCESS));
                } catch (e) {
                    dispatch(this.setSliceLoadingFavoriteListStatusAction(FJConstant.ERROR));
                }
            } else {
                dispatch(this.setSliceLoadingFavoriteListStatusAction(FJConstant.SUCCESS));
            }
        };
    },

    onFavoriteAction: function (id, isNeedFavorite) {
        return async (dispatch, getState) => {
            const __error = isNeedFavorite => {
                FJMessageStore.addMessage(
                    FJLocalStore._(
                        isNeedFavorite
                            ? 'failed-to-favorite-please-try-again'
                            : 'failed-to-unfavorite-please-try-again',
                    ),
                    'error',
                );
            };

            const state = getState();
            const { loadingFavoriteIdList } = state.textToSpeech;
            const newLoadingFavoriteIdList = [...loadingFavoriteIdList, id];
            dispatch(this.setLoadingFavoriteIdListAction(newLoadingFavoriteIdList));

            if (isNeedFavorite) {
                const { voiceInfo } = state.textToSpeech;
                let voiceList = [];
                for (const key in voiceInfo) {
                    const innerItem = voiceInfo[key];
                    voiceList = [...voiceList, ...innerItem];
                }
                const defaultVoiceItem = voiceList.find(item => item.value === id);
                const { text, languageInfo } = defaultVoiceItem;
                FJUtil.eaLog('voice_favorite', { language: languageInfo.label, voice_name: text });
            }

            try {
                const { code } = await FJNetworkStore.soundCollection(id);
                const { loadingFavoriteIdList } = getState().textToSpeech;
                dispatch(this.setLoadingFavoriteIdListAction(loadingFavoriteIdList.filter(item => item !== id)));
                if (code === 200) {
                    dispatch(this.getFavoriteAction());
                } else if (code === 214) {
                    FJUtil.login();
                } else {
                    __error(isNeedFavorite);
                }
            } catch (e) {
                __error(isNeedFavorite);
                const { loadingFavoriteIdList } = getState().textToSpeech;
                dispatch(this.setLoadingFavoriteIdListAction(loadingFavoriteIdList.filter(item => item !== id)));
            }
        };
    },

    openLibraryModalAction: function () {
        return dispatch => {
            FJAudioPlayManager.pauseAll();
            dispatch(this.setIsShowLibraryModalAction(true));
        };
    },

    hideLibraryModalAction: function () {
        return dispatch => {
            FJAudioPlayManager.pauseAll();
            dispatch(this.setIsShowLibraryModalAction(false));
        };
    },

    useVoiceItemAction: function (info, options = {}) {
        return (dispatch, getState) => {
            FJAudioPlayManager.pauseAll();
            const { isAdd = false, fromType = FJConstant.MICROSOFT } = options;

            const { voiceInfo } = getState().textToSpeech;
            let voice_name = '';
            let language = '';
            switch (fromType) {
                case FJConstant.MICROSOFT: {
                    let voiceList = [];
                    for (const key in voiceInfo) {
                        const innerItem = voiceInfo[key];
                        voiceList = [...voiceList, ...innerItem];
                    }
                    const defaultVoiceItem = voiceList.find(item => item.value === info.value);
                    if (defaultVoiceItem) {
                        const { text, languageInfo } = defaultVoiceItem;
                        voice_name = text;
                        language = languageInfo.label;
                    }
                    break;
                }
                case FJConstant.CLONE_BY_SELF: {
                    const { name, lang } = info;
                    voice_name = name;
                    language = lang;
                    break;
                }
            }
            FJUtil.eaLog('change_voice_click', {
                language: language,
                categary: fromType === FJConstant.MICROSOFT ? 'library' : 'clone',
                voice_name: voice_name,
            });

            if (isAdd) {
                const state = getState();
                const { currentSpeechList } = state.textToSpeech;

                if (currentSpeechList.length === MAX_LIMIT) {
                    FJMessageStore.addMessage(FJLocalStore._('you-can-add-up-to-sections-in-total'), 'error');
                    return;
                }
                dispatch(this.addSpeechParagraphAction());
            }
            dispatch(this.setSliceCurrentVoiceFromTypeAction(fromType));

            dispatch(this.updateTextToSpeechVoiceInfoAction(info, { fromType: fromType }));
            dispatch(this.hideLibraryModalAction());
            dispatch(this.updateCurrentItemInfoAction());
            dispatch(this.addRecentUsedVoiceListAction(info, options));
            dispatch(this.changeTabIndexAction(0));
            dispatch(this.updateBottomTotalTimeAction(0));
            dispatch(this.updateBottomCurrentTimeAction(0));
        };
    },

    addRecentUsedVoiceListAction: function (info, options) {
        return (dispatch, getState) => {
            const { fromType = FJConstant.MICROSOFT } = options;
            const state = getState();
            const recentUseVoiceList = [...state.textToSpeech.recentUseVoiceList];

            // 移除已存在的相同id的项
            const filteredList = recentUseVoiceList.filter(item => (item.id || item.value) !== (info.id || info.value));

            // 添加新项到列表开头
            filteredList.unshift({ ...info, fromType: fromType });

            // 限制列表长度为10
            const finalList = filteredList.slice(0, 10);

            dispatch(this.setSliceRecentUseVoiceListAction(finalList));
            FJTextToSpeechUtil.setRecentUseVoiceList(finalList);
        };
    },

    deleteRecentUsedVoiceListAction: function (ids = []) {
        return (dispatch, getState) => {
            const state = getState();
            const recentUseVoiceList = [...state.textToSpeech.recentUseVoiceList];
            // 移除已存在的相同id的项
            const filteredList = recentUseVoiceList.filter(item => ids.indexOf(item.id || item.value) === -1);
            dispatch(this.setSliceRecentUseVoiceListAction(filteredList));
            FJTextToSpeechUtil.setRecentUseVoiceList(filteredList);
        };
    },

    addSpeechParagraphAction: function (insertIndex) {
        return (dispatch, getState) => {
            const state = getState();
            const { currentSpeechList, currentVoiceFromType, currentName, currentStyle, currentSpeed, currentPitch } =
                state.textToSpeech;

            if (currentSpeechList.length === MAX_LIMIT) {
                FJMessageStore.addMessage(FJLocalStore._('you-can-add-up-to-sections-in-total'), 'error');
                return;
            }

            let voiceInfo = {};
            switch (currentVoiceFromType) {
                case FJConstant.MICROSOFT: {
                    voiceInfo = {
                        value: f_currentVoiceInfo.value,
                        name: currentName,
                        styleId: currentStyle,
                        speed: currentSpeed,
                        pitch: currentPitch,
                        languageValue: f_currentVoiceInfo.languageInfo.value,
                    };
                    break;
                }
                case FJConstant.CLONE_BY_SELF: {
                    const { currentVoiceUrl, currentAvatarUrl, currentName, currentCountryInfo } = state.textToSpeech;
                    voiceInfo = {
                        audioUrl: currentVoiceUrl,
                        imgUrl: currentAvatarUrl,
                        name: currentName,
                        showLang: currentCountryInfo.showLang,
                        readText: currentCountryInfo.readText,
                        id: currentCountryInfo.id,
                    };
                    break;
                }
                case FJConstant.CLONE_BY_FLEX_CLIP: {
                    const { currentName, currentCountryInfo } = state.textToSpeech;
                    voiceInfo = {
                        value: currentCountryInfo.value,
                        name: currentName,
                        languageInfo: currentCountryInfo,
                    };
                    break;
                }
                default:
            }

            const id = new Date().getTime();
            const itemSpeech = {
                ...FJTextToSpeechData.DEFAULT_SPEECH_INFO,
                generationType: currentVoiceFromType,
                voiceInfo: { ...voiceInfo },
                id,
            };

            if (insertIndex === undefined) {
                dispatch(this.setSliceCurrentSpeechListAction([...currentSpeechList, itemSpeech]));
            } else {
                const newSpeechList = [...currentSpeechList];
                newSpeechList.splice(insertIndex, 0, itemSpeech);
                dispatch(this.setSliceCurrentSpeechListAction(newSpeechList));
            }
            dispatch(this.setSliceSpeechSelectIdAction(id));
        };
    },

    updateVoiceInfoAction: function () {
        return (dispatch, getState) => {
            const state = getState();
            const { speechSelectId, currentSpeechList } = state.textToSpeech;
            const item = currentSpeechList.find(item => item.id === speechSelectId);
            if (item) {
                dispatch(this.setSliceCurrentVoiceFromTypeAction(item.generationType));
                switch (item.generationType) {
                    case FJConstant.MICROSOFT: {
                        dispatch(
                            this.updateTextToSpeechVoiceInfoAction(item.voiceInfo, { fromType: item.generationType }),
                        );
                        dispatch(this.setSliceCurrentStyleAction(item.voiceInfo.styleId));
                        dispatch(this.setSliceCurrentSpeedAction(item.voiceInfo.speed));
                        dispatch(this.setSliceCurrentPitchAction(item.voiceInfo.pitch));
                        break;
                    }
                    case FJConstant.CLONE_BY_SELF: {
                        const { audioUrl, imgUrl, name, showLang, readText, id } = item.voiceInfo;
                        dispatch(this.setSliceCurrentAvatarUrlAction(imgUrl));
                        dispatch(this.setSliceCurrentVoiceUrlAction(audioUrl));
                        dispatch(this.setSliceCurrentNameAction(name));
                        dispatch(this.setSliceCurrentCountryInfoAction({ showLang: showLang, readText: readText, id }));
                        break;
                    }
                    case FJConstant.CLONE_BY_FLEX_CLIP: {
                        const { value, name, languageInfo } = item.voiceInfo;
                        dispatch(this.setSliceCurrentAvatarUrlAction(FJTextToSpeechUtil.getVoiceStyleImgUrl(value)));
                        dispatch(this.setSliceCurrentVoiceUrlAction(FJTextToSpeechUtil.getVoiceStyleAudioUrl(value)));
                        dispatch(this.setSliceCurrentNameAction(name));
                        dispatch(this.setSliceCurrentCountryInfoAction({ ...languageInfo }));
                        break;
                    }
                    default:
                }
            }
        };
    },

    updateCurrentItemInfoAction: function () {
        return (dispatch, getState) => {
            const state = getState();
            const { speechSelectId, currentSpeechList } = state.textToSpeech;
            const { currentVoiceFromType, currentName, currentStyle, currentSpeed, currentPitch, currentCountryInfo } =
                state.textToSpeech;

            const newSpeechList = currentSpeechList.map(item => {
                if (item.id === speechSelectId) {
                    switch (currentVoiceFromType) {
                        case FJConstant.MICROSOFT: {
                            return {
                                ...item,
                                generationType: currentVoiceFromType,
                                voiceInfo: {
                                    value: f_currentVoiceInfo.value,
                                    name: currentName,
                                    styleId: currentStyle,
                                    speed: currentSpeed,
                                    pitch: currentPitch,
                                    languageValue: currentCountryInfo.value,
                                },
                                status: FJConstant.DEFAULT,
                            };
                        }
                        case FJConstant.CLONE_BY_SELF: {
                            const { audioUrl, avatar, name, lang, readText, id } = f_currentVoiceInfo;
                            const showLang =
                                FJTextToSpeechData.LANGUAGE_LIST.find(item => item.value === lang)?.label || 'English';
                            return {
                                ...item,
                                generationType: currentVoiceFromType,
                                voiceInfo: {
                                    audioUrl: audioUrl,
                                    imgUrl: FJConfig.profilePath + avatar + '.png',
                                    name: name,
                                    showLang: showLang,
                                    readText: readText,
                                    id: id,
                                },
                                status: FJConstant.DEFAULT,
                            };
                        }
                        case FJConstant.CLONE_BY_FLEX_CLIP: {
                            return {
                                ...item,
                                generationType: currentVoiceFromType,
                                voiceInfo: {
                                    value: currentCountryInfo.value,
                                    name: currentName,
                                    languageInfo: currentCountryInfo,
                                },
                                status: FJConstant.DEFAULT,
                            };
                        }
                    }
                }
                return item;
            });
            dispatch(this.setSliceCurrentSpeechListAction(newSpeechList));
        };
    },

    updateSpeechListPositionAction: function (id, moveInsertIndex) {
        return (dispatch, getState) => {
            const state = getState();
            const { currentSpeechList } = state.textToSpeech;

            let newList = [...currentSpeechList];
            let item = newList.find(item => item.id === id);
            const itemIdx = newList.findIndex(item => item.id === id);

            const insertIndex = moveInsertIndex < 1 ? 0 : moveInsertIndex;
            if (insertIndex === itemIdx || insertIndex - 1 === itemIdx) return;
            newList.splice(insertIndex, 0, item);
            const deleteIndex = insertIndex > itemIdx ? itemIdx : itemIdx + 1;
            newList.splice(deleteIndex, 1);

            dispatch(this.setSliceCurrentSpeechListAction(newList));
        };
    },

    onTextChangeAction: function (id, text) {
        return (dispatch, getState) => {
            const state = getState();
            const { currentSpeechList } = state.textToSpeech;
            const newSpeechList = currentSpeechList.map(item => {
                if (item.id === id) {
                    return {
                        ...item,
                        text: text,
                        status: FJConstant.DEFAULT,
                    };
                }
                return item;
            });
            dispatch(this.setSliceCurrentSpeechListAction(newSpeechList));
        };
    },

    openPlayCreditModalAction: function (callback = () => {}) {
        return dispatch => {
            dispatch(
                setSliceUpgradeTipsModalData({
                    display: true,
                    data: {
                        title: 'playing-will-consume-credits',
                        content: 'the-played-section-can-be-downloaded',
                        buttonType: FJConstant.SUBMIT,
                        callback: callback,
                    },
                }),
            );
        };
    },

    generateSpeechByIdAction: function (id) {
        return (dispatch, getState) => {
            const __func = () => {
                FJTTSPlayStore.enterPlayMode(id);
                const { currentSpeechList } = getState().textToSpeech;
                const itemSpeech = currentSpeechList.find(item => item.id === id);
                if (itemSpeech.text.trim() && itemSpeech.status === FJConstant.DEFAULT) {
                    dispatch(
                        this.startTextToSpeechAction([id], {
                            callback: () => {
                                try {
                                    setTimeout(() => {
                                        const { currentSpeechList, speechSelectId } = getState().textToSpeech;
                                        if (speechSelectId === id) {
                                            const itemSpeech = currentSpeechList.find(item => item.id === id);
                                            if (itemSpeech?.audioUrl) {
                                                FJTTSPlayStore.play(id);
                                            }
                                        }
                                    }, 1000);
                                } catch (e) {
                                    console.log(e);
                                }
                            },
                            fromType: FJConstant.PARAGRAPH_PLAY,
                        }),
                    );
                }
            };

            const dontShowPlayCreditTips = localStorage.getItem('dontShowPlayCreditTips');

            if (dontShowPlayCreditTips !== 'true') {
                dispatch(this.openPlayCreditModalAction(__func));
                localStorage.setItem('dontShowPlayCreditTips', 'true');
            } else {
                __func();
            }
        };
    },

    startTextToSpeechAction: function (idList, options = {}) {
        return async (dispatch, getState) => {
            const creditNumber = getState().common.creditNumber;
            const freeNumCreationTextToSpeech = getState().textToSpeech.freeNumCreationTextToSpeech;
            const { callback = () => {}, successCallback = () => {}, fromType } = options;
            const __error = () => {
                dispatch(this.setSliceDownloadStatusAction(FJConstant.DEFAULT));
                dispatch(FJActionModal.hideGenerateLoadingModalAction());
            };

            const __errorMessage = () => {
                if (fromType === FJConstant.PARAGRAPH_PLAY) {
                    FJMessageStore.addMessage(FJLocalStore._('playback-failed-please-try-again'), 'error');
                } else {
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-download-please-try-again'), 'error');
                }
            };

            const { currentSpeechList } = getState().textToSpeech;
            const { historyList } = getState().common;
            const needGenerateList = currentSpeechList.filter(item => idList.indexOf(item.id) !== -1);

            const customSpeechList = needGenerateList.filter(
                item =>
                    item.generationType === FJConstant.CLONE_BY_SELF ||
                    item.generationType === FJConstant.CLONE_BY_FLEX_CLIP,
            );

            // 判断 cloneSelfSpeechList 中有没有使用的音频被删除的情况
            const cloneSelfSpeechList = needGenerateList.filter(
                item => item.generationType === FJConstant.CLONE_BY_SELF,
            );
            const existInHistoryList = cloneSelfSpeechList.filter(
                item => historyList.findIndex(inner => inner.id === item.voiceInfo.id) !== -1,
            );
            if (existInHistoryList.length !== cloneSelfSpeechList.length) {
                FJMessageStore.addMessage(FJLocalStore._('the-current-voice-has-been-deleted'), 'error');
                __error();
                return;
            }

            const microsoftSpeechList = needGenerateList.filter(item => item.generationType === FJConstant.MICROSOFT);

            // 消耗积分数
            let consumedCredit = 0;

            const newSpeechList = currentSpeechList.map(item => {
                if (idList.indexOf(item.id) !== -1) {
                    consumedCredit =
                        consumedCredit + FJTextToSpeechUtil.getUsedCreditByTextLength(item.text.trim().length);
                    return {
                        ...item,
                        status: FJConstant.GENERATING,
                    };
                } else {
                    return item;
                }
            });
            dispatch(this.setSliceCurrentSpeechListAction(newSpeechList));

            try {
                const userSpaceType = await FJUtil.checkUserSpace({
                    errorCallback: () => {
                        throw new Error('checkUserSpace error');
                    },
                    beforeLoginCallback: () => {
                        __error();
                        dispatch(this.setCurrentSpeechStatusAction(idList, FJConstant.DEFAULT));
                        return;
                    },
                });

                if (userSpaceType > 0) {
                    dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                    dispatch(this.setCurrentSpeechStatusAction(idList, FJConstant.DEFAULT));
                    __error();
                    return;
                }

                if (consumedCredit > creditNumber && freeNumCreationTextToSpeech === 0) {
                    __error();
                    dispatch(FJActionModal.showUpgradeModalAction());
                    dispatch(this.setCurrentSpeechStatusAction(idList, FJConstant.DEFAULT));
                    return;
                }
            } catch (e) {
                __errorMessage();
                __error();
                dispatch(this.setCurrentSpeechStatusAction(idList, FJConstant.DEFAULT));
                return;
            }

            const isFree = consumedCredit > creditNumber && freeNumCreationTextToSpeech > 0;

            let successNum = 0;
            const _countSuccessCallback = () => {
                successNum++;
                if (successNum === 2) {
                    successCallback();

                    FJUtil.eaLog('ai tool generate success', {
                        tool: 'text_to_speech',
                        'credit&free': isFree ? 'free' : 'credit',
                    });
                }
            };

            FJUtil.eaLog(' ai tool start generating', {
                tool: 'text_to_speech',
                'credit&free': isFree ? 'free' : 'credit',
            });

            if (customSpeechList.length > 0) {
                const customEventId = await FJTextToSpeechStore.createTextToAudio(customSpeechList);
                dispatch(
                    this.pollingTaskAction(customEventId, {
                        ...options,
                        countSuccessCallback: _countSuccessCallback,
                    }),
                );
            } else {
                _countSuccessCallback();
            }

            if (microsoftSpeechList.length > 0) {
                let textLength = 0;
                const dealList = microsoftSpeechList.map(item => {
                    textLength = textLength + item.text.length;
                    return {
                        language_value: item.voiceInfo.languageValue,
                        voice_value: item.voiceInfo.value,
                        voice_style_value: item.voiceInfo.styleId,
                        voice_speed: (item.voiceInfo.speed - 1) * 100,
                        pitch: (item.voiceInfo.pitch - 1) * 50,
                        text_value: JSON.stringify([item.text]),

                        role_value: '',
                        secondary_value: '',
                    };
                });
                const microsoftIdList = microsoftSpeechList.map(item => item.id);
                try {
                    const microsoftResult = await FJTextToSpeechStore.batchSynthesis(dealList, {
                        timestamp: new Date().getTime(),
                    });

                    if (!microsoftResult) {
                        throw new Error('microsoft error');
                    }

                    const mp3Files = microsoftResult.entries.filter(i => i?.name?.includes('.mp3'));
                    mp3Files.sort((a, b) => +a.name.split('.')[0] - +b.name.split('.')[0]);

                    let keyList = [];
                    const _getFilesList = async () => {
                        return new Promise(resolve => {
                            const blobList = [];
                            let completedFiles = 0;

                            for (let i = 0; i < mp3Files.length; i++) {
                                const file = mp3Files[i];
                                file.getBlob('audio/mp3', blob => {
                                    const index = +file.name.split('.')[0] - 1;
                                    const key = FJUtil.createSimpleId();
                                    keyList.push({ id: microsoftSpeechList[index].id, key: key });
                                    blob.name = `${key}.mp3`;
                                    blobList[index] = blob;
                                    completedFiles++;

                                    if (completedFiles === mp3Files.length) {
                                        resolve(blobList);
                                    }
                                });
                            }
                        });
                    };

                    const uploadBlobList = await _getFilesList();

                    // 上传s3
                    for (let i = 0; i < uploadBlobList.length; i++) {
                        const file = uploadBlobList[i];
                        const key = FJTextToSpeechConfig.microsoftKey + file.name;
                        const uploadS3Result = await FJImageStore.upLoadFileToS3Async(file, key);
                        if (!uploadS3Result) {
                            throw new Error('upload s3 error');
                        }
                    }

                    const { currentSpeechList: tempCurrentSpeechLis } = getState().textToSpeech;
                    const newSpeechList = await Promise.all(
                        tempCurrentSpeechLis.map(async item => {
                            const index = microsoftIdList.indexOf(item.id);
                            if (index !== -1) {
                                const useKey = keyList.find(inner => inner.id === item.id).key;
                                const audioUrl = FJTextToSpeechConfig.microsoftKey + useKey + '.mp3';
                                let audioDuration = 0;
                                try {
                                    audioDuration = await FJFileHandleUtil.getAudioDurationWithUrl(
                                        URL.createObjectURL(uploadBlobList[index]),
                                    );
                                } catch (e) {
                                    throw new Error('audioDuration error');
                                }

                                return {
                                    ...item,
                                    status: FJConstant.SUCCESS,
                                    audioUrl: audioUrl,
                                    audioDuration: audioDuration,
                                    generateInfo: {
                                        text: item.text,
                                        voiceInfo: item.voiceInfo,
                                        generationType: item.generationType,
                                    },
                                };
                            } else {
                                return item;
                            }
                        }),
                    );
                    dispatch(this.setSliceCurrentSpeechListAction(newSpeechList));
                    callback();

                    _countSuccessCallback();
                } catch (e) {
                    __error();
                    __errorMessage();
                    dispatch(this.setCurrentSpeechStatusAction(microsoftIdList, FJConstant.DEFAULT));
                    _countSuccessCallback();
                    FJUtil.updateAllCreditInfo(isFree);
                }
            } else {
                _countSuccessCallback();
            }

            // if (isNeedDownload) {
            //     // 下载
            //     dispatch(this.multiDownloadByCurrentSpeechIdAction());
            // }

            dispatch(FJActionTextToSpeechProject.save());
        };
    },

    pollingTaskAction: function (idList, options = {}) {
        const { callback = () => {}, countSuccessCallback = () => {} } = options;

        let timer = null;

        let errorTime = 0;
        let finishTaskCount = 0;
        let failTaskCount = 0;
        let allTaskCount = idList.length;

        const eventIdList = idList.map(item => item.eventId);

        return async dispatch => {
            const _clear = () => {
                if (timer) {
                    clearTimeout(timer);
                    timer = null;
                }
            };

            const _request = async eventIdList => {
                try {
                    const result = await FJNetworkStore.getTaskState(eventIdList.join(','));
                    let isStopPolling = false;
                    let data = result;

                    if (!data) {
                        errorTime++;
                        if (errorTime >= MAX_POLLING_ERROR_TIME) {
                            isStopPolling = true;
                        } else {
                            timer = setTimeout(_request.bind(null, eventIdList), TASK_POLLING_INTERVAL);
                        }
                        return;
                    }

                    if (!Array.isArray(result)) {
                        // 处理数组类型的data
                        data = [result];
                    }

                    let allTaskStatus = '';
                    const curEventIdList = [...eventIdList];
                    await Promise.all(
                        data.map(async item => {
                            switch (item.job_state) {
                                case 'succeeded':
                                    if (item.out_put) {
                                        await dispatch(
                                            this.updateSpeechItemStatusAndUrlAction(
                                                idList.find(inner => inner.eventId === item.event_id).speechId,
                                                item.out_put[0].result,
                                            ),
                                        );
                                        callback();
                                    } else {
                                        failTaskCount++;
                                    }
                                    curEventIdList.splice(curEventIdList.indexOf(item.event_id), 1);
                                    finishTaskCount++;
                                    break;
                                case 'waiting':
                                    break;
                                case 'processing':
                                    break;
                                case 'canceled':
                                    break;
                                case 'timeout':
                                case 'failed':
                                    failTaskCount++;
                                    finishTaskCount++;
                                    curEventIdList.splice(curEventIdList.indexOf(item.event_id), 1);
                                    if (failTaskCount === allTaskCount) {
                                        allTaskStatus = 'failed';
                                    }
                                    dispatch(
                                        this.setCurrentSpeechStatusAction(
                                            [idList.find(inner => inner.eventId === item.event_id).speechId],
                                            FJConstant.DEFAULT,
                                        ),
                                    );
                                    FJUtil.updateAllCreditInfo(true);
                                    break;
                                default:
                                    break;
                            }
                        }),
                    );

                    // 全部任务完成, 并且美元全部失败 则更改状态为成功
                    if (finishTaskCount >= allTaskCount) {
                        allTaskStatus !== 'failed' && (allTaskStatus = 'succeeded');
                    }

                    if (allTaskStatus) {
                        switch (allTaskStatus) {
                            case 'succeeded': {
                                isStopPolling = true;
                                countSuccessCallback();
                                break;
                            }
                            case 'waiting':
                                break;
                            case 'processing':
                                break;
                            case 'canceled':
                                isStopPolling = true;
                                break;
                            case 'failed':
                                isStopPolling = true;
                                break;
                            default:
                                break;
                        }

                        errorTime = 0;
                    }
                    if (isStopPolling) {
                        _clear();
                    } else {
                        timer = setTimeout(_request.bind(null, curEventIdList), TASK_POLLING_INTERVAL);
                    }
                } catch (error) {
                    console.log(error);
                    dispatch(
                        this.setCurrentSpeechStatusAction(
                            idList.map(item => item.speechId),
                            FJConstant.DEFAULT,
                        ),
                    );
                    _clear();
                }
            };

            timer = setTimeout(_request.bind(null, eventIdList), TASK_POLLING_INTERVAL);
        };
    },

    setCurrentSpeechStatusAction: function (ids, status) {
        return (dispatch, getState) => {
            const { currentSpeechList } = getState().textToSpeech;

            const newSpeechList = currentSpeechList.map(item => {
                if (ids.indexOf(item.id) !== -1) {
                    return { ...item, status: status };
                } else {
                    return { ...item };
                }
            });

            dispatch(this.setSliceCurrentSpeechListAction(newSpeechList));
        };
    },

    updateSpeechItemStatusAndUrlAction: function (id, result) {
        return async (dispatch, getState) => {
            const { currentSpeechList } = getState().textToSpeech;

            // 创建新的列表来存储更新后的数据
            const newSpeechList = [...currentSpeechList];

            // 找到需要更新的项目的索引
            const updateIndex = newSpeechList.findIndex(item => item.id === id);

            if (updateIndex !== -1) {
                const audioUrl = result;
                // 获取音频时长
                const audioDuration = await FJFileHandleUtil.getAudioDurationWithUrl(
                    FJS3Config.S3_SERVER_HOST + FJConfig.resultAudioKey + audioUrl,
                );

                // 更新特定项目
                newSpeechList[updateIndex] = {
                    ...newSpeechList[updateIndex],
                    status: FJConstant.SUCCESS,
                    audioUrl: audioUrl,
                    audioDuration: audioDuration,
                    generateInfo: {
                        text: newSpeechList[updateIndex].text,
                        voiceInfo: newSpeechList[updateIndex].voiceInfo,
                        generationType: newSpeechList[updateIndex].generationType,
                    },
                };
            }

            dispatch(this.setSliceCurrentSpeechListAction(newSpeechList));
            dispatch(FJActionTextToSpeechProject.save());
        };
    },

    /**
     * @description
     * @param selectIdList
     * @returns {(function(*): void)|*}
     */
    onEditToFlexCliAction: function (selectIdList) {
        return dispatch => {
            dispatch(this.onDownloadAction(selectIdList, { isEditToFlexClip: true }));
        };
    },

    /**
     * @description
     * @param selectIdList
     * @param options
     * @returns {(function(*, *): void)|*}
     */
    onDownloadAction: function (selectIdList, options = {}) {
        return (dispatch, getState) => {
            const { isEditToFlexClip = false } = options;

            // 记录要保存的json数据
            dispatch(FJActionTextToSpeechProject.recordSaveSpeechListAction(selectIdList));
            f_recordNeedDownloadIdList = [...selectIdList];
            const { currentSpeechList } = getState().textToSpeech;
            const needGenerateList = currentSpeechList
                .filter(
                    item => f_recordNeedDownloadIdList.indexOf(item.id) !== -1 && item.status === FJConstant.DEFAULT,
                )
                .map(item => item.id);
            dispatch(this.setSliceDownloadStatusAction(FJConstant.LOADING));
            if (needGenerateList.length > 0) {
                let totalCre = 0;
                const useList = currentSpeechList.filter(
                    item => f_recordNeedDownloadIdList.indexOf(item.id) !== -1 && item.status === FJConstant.DEFAULT,
                );
                useList.forEach(item => {
                    totalCre = totalCre + FJTextToSpeechUtil.getUsedCreditByTextLength(item.text.trim().length);
                });
                totalCre = parseFloat(totalCre.toFixed(3));
                if (isEditToFlexClip) {
                    FJUtil.eaLog('use_in_flexclip_click', {
                        position: 'whole_download',
                        section_num: selectIdList.length,
                        credits: totalCre,
                    });
                } else {
                    FJUtil.eaLog('speech_download_click', {
                        position: 'whole_download',
                        section_num: selectIdList.length,
                        credits: totalCre,
                    });
                }

                dispatch(FJActionModal.showGenerateLoadingModalAction(FJLocalStore._('generating...')));
                dispatch(
                    this.startTextToSpeechAction(needGenerateList, {
                        successCallback: () => {
                            if (isEditToFlexClip) {
                                const downloadList = getState().textToSpeech.currentSpeechList.filter(
                                    item =>
                                        f_recordNeedDownloadIdList.indexOf(item.id) !== -1 &&
                                        item.status === FJConstant.SUCCESS,
                                );
                                dispatch(FJActionTextToSpeechProject.onUseToFlexClipAction(downloadList));
                            } else {
                                dispatch(this.multiDownloadByCurrentSpeechIdAction(f_recordNeedDownloadIdList));
                            }
                        },
                    }),
                );
            } else {
                if (isEditToFlexClip) {
                    const downloadList = currentSpeechList.filter(
                        item =>
                            f_recordNeedDownloadIdList.indexOf(item.id) !== -1 && item.status === FJConstant.SUCCESS,
                    );
                    dispatch(FJActionTextToSpeechProject.onUseToFlexClipAction(downloadList));
                } else {
                    dispatch(this.multiDownloadByCurrentSpeechIdAction(f_recordNeedDownloadIdList));
                }
            }
        };
    },

    multiDownloadByCurrentSpeechIdAction: function (ids) {
        return (dispatch, getState) => {
            const state = getState();
            const { currentSpeechList } = state.textToSpeech;
            const urlList = currentSpeechList
                .filter(item => ids.indexOf(item.id) !== -1 && item.audioUrl)
                .map(item => {
                    switch (item.generationType) {
                        case FJConstant.MICROSOFT:
                            return FJS3Config.S3_SERVER_HOST + item.audioUrl;
                        case FJConstant.CLONE_BY_SELF:
                        case FJConstant.CLONE_BY_FLEX_CLIP:
                            return FJS3Config.S3_SERVER_HOST + FJConfig.resultAudioKey + item.audioUrl;
                        default:
                            return item.audioUrl;
                    }
                });
            dispatch(this.multiDownloadAction(urlList));
        };
    },

    multiDownloadAction: function (urlList) {
        return async (dispatch, getState) => {
            const __callback = () => {
                dispatch(this.setSliceDownloadStatusAction(FJConstant.DEFAULT));
                dispatch(FJActionModal.hideGenerateLoadingModalAction());
            };

            await FJUtil.multiDownloadByUrls(urlList, __callback, {
                isZipDownload: true,
                isAudioGenerator: true,
                downloadHistoryList: [],
            });
        };
    },

    deleteSpeechByIdAction: function (id) {
        return (dispatch, getState) => {
            const { currentSpeechList } = getState().textToSpeech;
            let findIndex = currentSpeechList.findIndex(item => item.id === id);
            const newSpeechList = currentSpeechList.filter(item => item.id !== id);
            dispatch(this.setSliceCurrentSpeechListAction(newSpeechList));
            if (findIndex === currentSpeechList.length - 1) {
                findIndex = findIndex - 1;
            }
            dispatch(this.setSliceSpeechSelectIdAction(newSpeechList[findIndex].id));
            dispatch(this.updateVoiceInfoAction());
            dispatch(FJActionTextToSpeechProject.save());
        };
    },

    updateBottomCurrentTimeAction: function (duration) {
        return dispatch => {
            dispatch(this.setSliceCurrentBottomCurrentTimeAction(duration));
        };
    },

    updateBottomTotalTimeAction: function (duration) {
        return dispatch => {
            dispatch(this.setSliceCurrentBottomTotalTimeAction(duration));
        };
    },
};

export default FJActionTextToSpeech;
